import { ONBOARDING_MODULE_METADATA } from "./moduleVersions";
import type { ModuleConfig } from "./types";

const workspaceIntroImageSrc = `${import.meta.env.VITE_BASE_PATH || "/"}images/onboarding_workspace-1.png`;

// tourId of the "Main Features" step, anchored on the Analysis nav item. The
// sidebar reads this to spotlight the whole sidebar while the Analysis item
// renders active. Exported (not inlined in the sidebar) for a single source of truth.
export const WORKSPACE_ANALYSIS_TOUR_ID = "workspace-analysis";

// Minimal info-only tour, useful as a smoke test for the framework.
export const workspaceTourConfig: ModuleConfig = {
  code: ONBOARDING_MODULE_METADATA.workspaceTour.code,
  version: ONBOARDING_MODULE_METADATA.workspaceTour.version,
  route: "/",
  intro: {
    title: "LOKASI Workspace",
    description:
      "Get to know the key tools and features that help you explore, analyze, and manage location intelligence",
    image: {
      src: workspaceIntroImageSrc,
      alt: "LOKASI workspace map tools preview"
    },
    actions: [
      {
        label: "Let's Start",
        type: "start"
      }
    ]
  },
  steps: [
    {
      id: "main-features",
      tourId: WORKSPACE_ANALYSIS_TOUR_ID,
      title: "Main Features",
      description:
        "Access the platform's core features here from workspace overview to your key analysis modules.",
      tooltipConfig: {
        placement: "right-start",
        placementOffset: { crossAxis: 72 },
        arrowOffset: 18
      },
      targetPadding: 0
    },
    {
      id: "account-settings",
      tourId: "sidebar-footer",
      title: "Account & Settings",
      description:
        "Manage your profile, team access, and workspace preferences from this section.",
      tooltipConfig: {
        placement: "left"
      },
      // Flush with the sidebar width (x: 0) so the hole doesn't spill into the
      // map. Keep bottom padding at 0 so the lower radius is not clipped by the
      // viewport when the footer sits at the bottom edge.
      targetPadding: { x: 0, top: 16, bottom: 0 },
      targetRadius: { topRight: 16, bottomRight: 16 }
    },
    {
      id: "track-analysis",
      tourId: "analysis-job-queue-control",
      title: "Track Your Analysis",
      description:
        "Monitor the progress of your active analyses and jump back to where you left off.",
      tooltipConfig: {
        placement: "bottom-end"
      },
      targetPadding: 6
    },
    {
      id: "map-tools",
      tourId: "map-tools-control",
      title: "Map Tools",
      description:
        "Control your map view , draw zones, adjust layers, set the legend, and zoom to your area of interest.",
      tooltipConfig: {
        placement: "right"
      },
      targetPadding: 6
    }
  ]
};
